import { yupResolver } from "@hookform/resolvers/yup";
import TableContainer from "Components/Common/TableContainer";
import {
  formatarDataBanco,
  formatarDataHora,
} from "helpers/fomatar-data.helper";
import { isEmpty } from "lodash";
import ParticlesAuth from "pages/AuthenticationInner/ParticlesAuth";
import React, { useEffect, useMemo, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import {
  Alert,
  Card,
  CardHeader,
  Col,
  Container,
  Form,
  Input,
  Label,
  Row,
} from "reactstrap";
import { createSelector } from "reselect";
import { relatorio } from "slices/Empresa/thunk";
import * as Yup from "yup";

const Impressao = () => {
  document.title = "Fila de atendimento :: Relatório";
  const dispatch: any = useDispatch();
  const selectLayoutState = (state: any) => state.ControleAtendimento;
  const selectLayoutProperties = createSelector(selectLayoutState, (state) => ({
    relatorioList: state.relatorioList,
    isControleAtendimentoSuccess: state.isControleAtendimentoSuccess,
  }));
  const { relatorioList, isControleAtendimentoSuccess } = useSelector(
    selectLayoutProperties
  );
  const [
    controleAtendimentoAutoAtendimentoList,
    setControleAtendimentoAutoAtendimentoList,
  ] = useState<any>([]);
  const [itensPorPagina, setItensPorPagina] = useState<number>(10);
  const [currentPage, setCurrentPage] = useState(0);

  useEffect(() => {
    setControleAtendimentoAutoAtendimentoList(relatorioList);
  }, [relatorioList]);

  useEffect(() => {
    setControleAtendimentoAutoAtendimentoList(relatorioList);
  }, [relatorioList]);

  useEffect(() => {
    if (!isEmpty(relatorioList))
      setControleAtendimentoAutoAtendimentoList(relatorioList.resultados);
  }, [relatorioList]);

  const handlePageChange = (newPage: number) => {
    setCurrentPage(newPage);
    setItensPorPagina(10);
    atualizar(newPage, itensPorPagina, null);
  };

  useEffect(() => {
    atualizar(0, 10, null);
  }, [dispatch]);

  const validationSchema = Yup.object({
    data: Yup.string().required("Data é obrigatório !"),
  });

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      data: formatarDataBanco(new Date()),
    },
  });

  const onSubmit = async (data: any) => {
    console.log(data);
    atualizar(0, 10, data?.data);
  };

  const atualizar = (page: number, limit: number, data: any) => {
    dispatch(
      relatorio({
        page,
        limit: 100000,
        data,
      })
    );
  };

  const columns = useMemo(
    () => [
      {
        header: "Empresa",
        accessorKey: "nome",
        enableColumnFilter: false,
        cell: (cell: any) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                <p className="text-muted mb-0">
                  <span className="fw-medium">{cell.row.original.nome}</span>
                </p>
              </div>
            </div>
          </>
        ),
      },
      {
        header: "Liberado",
        accessorKey: "liberado",
        enableColumnFilter: false,
        cell: (cell: any) => (
          <React.Fragment>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                <p className="text-muted mb-0">
                  <span className="fw-medium">
                    {cell.row.original.liberado === "SIM" ? "Sim" : "Não"}
                  </span>
                </p>
              </div>
            </div>
          </React.Fragment>
        ),
      },
      {
        header: "Atendeu",
        accessorKey: "finalizou",
        enableColumnFilter: false,
        cell: (cell: any) => (
          <React.Fragment>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                <p className="text-muted mb-0">
                  <span className="fw-medium">
                    {cell.row.original.finalizou === "SIM" ? "Sim" : "Não"}
                  </span>
                </p>
              </div>
            </div>
          </React.Fragment>
        ),
      },
      {
        header: "Data / hora entrada",
        accessorKey: "criacao",
        enableColumnFilter: false,
        cell: (cell: any) => (
          <React.Fragment>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                <p className="text-muted mb-0">
                  <span className="fw-medium">
                    {formatarDataHora(cell.row.original.criacao)}
                  </span>
                </p>
              </div>
            </div>
          </React.Fragment>
        ),
      },
      {
        header: "Data / hora atendimento",
        accessorKey: "atualizacao",
        enableColumnFilter: false,
        cell: (cell: any) => (
          <React.Fragment>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                <p className="text-muted mb-0">
                  <span className="fw-medium">
                    {cell.row.original.finalizou === "SIM"
                      ? formatarDataHora(cell.row.original.atualizacao)
                      : null}
                  </span>
                </p>
              </div>
            </div>
          </React.Fragment>
        ),
      },
    ],
    []
  );

  return (
    <React.Fragment>
      <div>
        <ParticlesAuth>
          <Container fluid>
            <Row style={{ textAlign: "center", paddingBottom: 20 }}>
              <h3> Todos Atendimentos</h3>
              <div className="hstack justify-content-center">
                <Link to="/">
                  <button
                    type="submit"
                    className="btn btn-warning"
                    id="add-btn"
                  >
                    <i className={"bx bx-arrow-back"}></i>Controle de
                    atendimento
                  </button>
                </Link>
              </div>
            </Row>
            <Card id="controleAtendimentoList">
              <CardHeader className="border-0">
                <Form
                  noValidate
                  autoComplete="off"
                  className="tablelist-form"
                  onSubmit={handleSubmit(onSubmit)}
                >
                  <div style={{ paddingBottom: 15 }}>
                    <Col lg={12}>
                      <div className="live-preview">
                        <Row>
                          <Col lg={2}>
                            <Label for="nome" className="form-label">
                              Data de pesquisa
                            </Label>
                            <Controller
                              name="data"
                              control={control}
                              render={({ field }) => (
                                <Input
                                  {...field}
                                  type="date"
                                  className="form-control"
                                  value={field.value || ""}
                                  onChange={(e) =>
                                    field.onChange(e.target.value)
                                  }
                                  invalid={!!errors.data}
                                />
                              )}
                            />
                          </Col>
                          <Col xxl={1} md={1}>
                            <div className="hstack" style={{ paddingTop: 27 }}>
                              <button
                                type="submit"
                                className="btn btn-light"
                                id="add-btn"
                              >
                                Pesquisar
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  </div>
                </Form>
                {isControleAtendimentoSuccess &&
                controleAtendimentoAutoAtendimentoList.length > 0 ? (
                  <TableContainer
                    columns={columns}
                    data={controleAtendimentoAutoAtendimentoList || []}
                    customPageSize={itensPorPagina}
                    divClass="table-responsive"
                    tableClass=""
                    theadClass="table-light"
                    totalPaginas={relatorioList?.totalPaginas || 1}
                    currentPage={currentPage}
                    onPageChange={handlePageChange}
                    totalRegistros={relatorioList?.totalPagina || 0}
                    itensPorPagina={itensPorPagina}
                    aparecerHeader={true}
                    aparecerPaginacao={false}
                  />
                ) : (
                  <Alert color="danger" className="border-0 mb-xl-0">
                    <i className="ri-error-warning-line label-icon"></i>
                    <strong style={{ paddingLeft: "10px" }}>
                      Sem registros
                    </strong>{" "}
                    !!!
                  </Alert>
                )}
              </CardHeader>
            </Card>
          </Container>
        </ParticlesAuth>
      </div>
      <ToastContainer closeButton={false} limit={1} />
    </React.Fragment>
  );
};

export default Impressao;
